import { defineStore } from "pinia";
import { ref, watch } from "vue";
import i18n from "@/i18n";

const DEFAULT_LOCALE = "ms-my";

const readStoredLocale = () => {
  if (typeof window === "undefined") return null;
  try {
    return localStorage.getItem("app_language_code");
  } catch {
    return null;
  }
};

const readStoredId = () => {
  if (typeof window === "undefined") return null;
  try {
    return localStorage.getItem("app_language_id");
  } catch {
    return null;
  }
};

export const useLanguageStore = defineStore("language", () => {
  const initialLocale = readStoredLocale() || DEFAULT_LOCALE;
  const initialId = Number(readStoredId() || (initialLocale === "en-gbr" ? 2 : 1));

  const locale = ref(initialLocale);
  const localeId = ref(initialId);

  const syncLocale = (value) => {
    const current = i18n.global.locale.value;
    if (current !== value) {
      i18n.global.locale.value = value;
    }
  };

  const setLanguage = ({ code, id }) => {
    if (code) {
      locale.value = code;
      try {
        localStorage.setItem("app_language_code", code);
      } catch (error) {
        console.error("Failed to persist language code", error);
      }
    }
    if (typeof id !== "undefined") {
      localeId.value = id;
      try {
        localStorage.setItem("app_language_id", String(id));
      } catch (error) {
        console.error("Failed to persist language id", error);
      }
    }
    syncLocale(locale.value);
  };

  watch(
    locale,
    (value) => {
      syncLocale(value);
    },
    { immediate: true }
  );

  return {
    locale,
    localeId,
    setLanguage,
  };
});
